import { collection, get, query, where } from "typesaurus"
import { LicenseType } from "../types"

export interface LicensesSet {
  id: string
  name: string
  navCategory: string
  navName: string
  licensable: boolean
  licenseTypes: LicenseType[]
  isExpired?: boolean
  licenseSet?: string
  licensedUsers?: { [key: string]: string }
  position?: number
  deleted?: boolean
  endDate?: number
  startDate?: number
  program?: string
}

const collection_ref = collection<LicensesSet>("licensesSets")

export const getLicensesSetById = (id: string) => {
  return get(collection_ref, id)
}

export const getLicensesSetsByLicensable = (value = true) => {
  return query(collection_ref, [where("licensable", "==", value)])
}
